import { FC } from 'react';

import Code from '../../../Shared/Code';
import ContentGenerator from '../../../Shared/ContentGenerator';

import { useChatContext } from '../../ChatController/ChatController.context';

import { Content } from '../../../../types/tour';

export type Props = {
  setComplete: (stepIndex: number, parentIndex: number) => void;
  content: Content;
};

const codeSample = (messageId: string) => `
const messageId = "${messageId}";

const reaction = await channel.sendReaction(messageId, {
  type: "love"
});

return reaction;
`;

export const Step5: FC<Props> = ({ setComplete, content }) => {
  const { addReaction, state } = useChatContext();

  const run = async () => {
    await addReaction();
    setComplete(5, 4);
  };

  return (
    <ContentGenerator
      content={content}
      code={
        <Code language="jsx" footer={{ label: 'Add Reaction', run }}>
          {codeSample(state?.message?.id)}
        </Code>
      }
    />
  );
};
